import { useScrollAnim } from "../../hook/useScrollAnim";
import vitrine1 from "../../../assets/img/projects/People/people-vitrine1.png";
import vitrine2 from "../../../assets/img/projects/People/people-vitrine2.png";
import vitrine3 from "../../../assets/img/projects/People/people-vitrine3.png";

export default function Card() {
  const containerRef = useScrollAnim({
    selector: ".people-vitrine img",
    threshold: 0.25,
    once: true,
  });

  return (
    <div className="people-vitrine" ref={containerRef}>
      <img src={vitrine2} alt="People Vitrine 2" />
      <img src={vitrine1} alt="People Vitrine 1" />
      <img src={vitrine3} alt="People Vitrine 3" />
    </div>
  );
}
